export default __webpack_public_path__ + "static/media/manual-adjustment-icon.e4ab9571.svg";